<app-title-bar titleText="i18n.domain.link-parker-to-user.title"></app-title-bar>
<div class="row">
  <div class="col-lg-6 col-md-8 offset-lg-3 offset-md-2">
    @if (!isUserAllowedToLinkParker) {
      <div class="alert alert-danger">
        {{ "i18n.domain.link-parker-to-user.message.user-not-allowed" | translate }}
      </div>
    } @else if(linkFailed){
      <div class="alert alert-danger">
        {{ errorTranslationString | translate }}
      </div>
    }

    @if (linkSuccessful) {
      @if (companyName) {
        <div class="alert alert-success" [innerHtml]="'i18n.domain.link-parker-to-user.message.link-successful' | translate: { parkerName , companyName }"></div>
      } @else {
        <div class="alert alert-success" [innerHtml]="'i18n.domain.link-parker-to-user.message.link-successful-no-company' | translate: { parkerName }"></div>
      }

      <label class="me-2">{{ 'i18n.shared.fields.assigned-parkers' | translate }}:</label>
      <ejs-grid #grid [dataSource]="linkedParkers">
        <e-columns>
          <e-column headerText='id' field='id' [visible]='false' [isPrimaryKey]='true'></e-column>
          <e-column [headerText]="'i18n.shared.fields.parkerId' | translate" field="parkerId" clipMode='EllipsisWithTooltip'></e-column>
          <e-column [headerText]="'i18n.shared.fields.parkerName' | translate" field="parkerName" clipMode='EllipsisWithTooltip'>
            <ng-template #template let-data>
              <span>{{data.firstName}} {{data.lastName}}</span>
            </ng-template>
          </e-column>
          <e-column [headerText]="'i18n.shared.fields.company' | translate" field="company.name" clipMode='EllipsisWithTooltip'>
            <ng-template #template let-data>
              <span>{{getCompanyName(data)}}</span>
            </ng-template>
          </e-column>
        </e-columns>
      </ejs-grid>
    }
  </div>
</div>
